import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	gap: 20px;
	grid-gap: 20px;
`;

export const InputContainer = styled.div`
	display: flex;
	width: 100%;
	gap: 10px;
	align-items: end;

	& > button {
		height: 45px;
	}

	div:first-child {
		width: 100%;
	}
`;
